export default __webpack_public_path__ + "static/media/air&Space.34d61ccd.png";